// PublicRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

const getRedirectByRole = (user) => {
  if (!user) return "/login";

  if (user.role === "HEALTH CENTER") {
    return "/laboratory-mapping/weekly-report";
  }

  if (user.role === "ZAMMSA") {
    return "/laboratory-mapping/labs";
  }

  return "/dashboard";
};

const PublicRoute = ({ children }) => {
  const { token, user } = useAuth();

  // ✅ If logged in → redirect
  if (token && user) {
    return <Navigate to={getRedirectByRole(user)} replace />;
  }

  // ❌ Not logged in → allow access
  return children;
};

export default PublicRoute;